<template>
  <base-form-dialog
    ref="baseDiaLog"
    dialog-type="edit"
    :form-config="formConfig"
    :form-data="formData"
    :dialog-visible="dialogVisible"
    v-bind="$attrs"
    @confirm="$emit('confirm', $event)"
    @cancel="$emit('cancel', $event)"
    @item-input="$emit('item-input', $event)"
    @item-change="$emit('item-change', $event)"
    @item-clear="$emit('item-clear', $event)"
    @item-blur="$emit('item-blur', $event)"
    @upload-error="$emit('upload-error', $event)"
    @update:dialogVisible="$emit('update:dialogVisible', $event)"
  >
    <template v-for="(_, slotName) in $scopedSlots" #[slotName]="scope">
      <slot :name="slotName" v-bind="scope"></slot>
    </template>
  </base-form-dialog>
</template>

<script>
import BaseFormDialog from './ajFormBase.vue'

export default {
  name: 'EditFormDialog',
  components: { BaseFormDialog },
  inheritAttrs: false,
  props: {
    formConfig: { type: Array, required: true },
    formData: { type: Object, required: true },
    dialogVisible: { type: Boolean, required: true }
  },
  methods: {
    cancelDiaLog () {
      this.$refs.baseDiaLog.handleCancel()
    }
  }
}
</script>
